import {Component, OnInit, ViewChild} from '@angular/core';
import {ProxyDynamicService} from '../shared/service/proxy-dynamic.service';
import {NzModalService} from 'ng-zorro-antd/modal';
import {NzNotificationService} from 'ng-zorro-antd/notification';
import {TranslateService} from '@ngx-translate/core';
import {
  DeleteStatus,
  exportAsExcelFile, formatFilter,
  GuestType,
  ItemMode,
  MasterDataStatus,
  PaymentMethod,
  SharedService, StickerStatus
} from '../shared/shared.service';
import {forkJoin, map} from 'rxjs';
import {DatePipe} from '@angular/common';
import {BillingItemComponent} from '../billing/billing-item/billing-item.component';
import moment from 'moment';
import {ModalImportComponent} from "./modal-import/modal-import.component";
import {ModalViewComponent} from "./modal-view/modal-view.component";

@Component({
  selector: 'app-stickers',
  templateUrl: './stickers.component.html',
  styleUrl: './stickers.component.scss'
})
export class StickersComponent implements OnInit {
  tableConfig: any[] = [];
  filterConfig: any[] = [];
  filter: any = {
    limit: 15,
    page: 1,
    sort: 'type, -seri',
    seri: null,
    type: null,
    status: null,
    posted_date: null,
    canceled_date: null,
  };
  source: any[] = [];
  listStickerStatus: any[] = [
    {text: "status.sticker_active", value: StickerStatus.Imported, class: 'active'},
    {text: "status.stick", value: StickerStatus.Posted, class: 'booked'},
    {text: "status.cancel", value: StickerStatus.Cancelled, class: 'canceled'}
  ];
  listStickerType: any[] = [];
  totalRows: number = 0;

  constructor(
    private service: ProxyDynamicService,
    private modalService: NzModalService,
    private noti: NzNotificationService,
    private translate: TranslateService,
    private datePipe: DatePipe,
    private sharedService: SharedService,
  ) {
  }

  ngOnInit() {
    this.getMasterData();
  }

  getMasterData() {
    this.sharedService.showLoading(true);
    const listAPI = [this.service.search('sticker_type', {filter: {deleted: {'_eq': DeleteStatus.NO}}, sort: '-code'})];
    forkJoin(listAPI).pipe(map(([listStickerType]) => ({
      listStickerType: listStickerType.map((item: any) => {
        item['text'] = item.code + ' - ' + item.name;
        item['code'] = item.code;
        item['name'] = item.name;
        item['value'] = item.id;
        return item;
      })
    }))).subscribe(e => {
      this.listStickerType = e.listStickerType;
      this.tableConfig = [
        {name: 'date', title: 'sticker.list_date', default: null, type: 'date', sortBy: 'ASC'},
        {name: 'seri', title: 'sticker.seri', default: null, type: 'textAsLink', sortBy: 'ASC'},
        {name: 'type', title: 'sticker.type', default: null, type: 'dropdown', options: e.listStickerType, sortBy: 'ASC'},
        {name: 'posted_date', title: 'sticker.stick_date', default: null, type: 'date', sortBy: 'ASC'},
        {name: 'cancelled_date', title: 'sticker.cancel_date', default: null, type: 'date', sortBy: 'ASC'},
        {name: 'status', title: 'status.title', default: null, type: 'status', options: this.listStickerStatus, sortBy: 'ASC'},
      ];
      this.filterConfig = [
        {name: 'seri', title: 'sticker.seri', default: '', type: 'text', col: 4},
        {name: 'type', title: 'sticker.type', default: '', type: 'dropdown', options: e.listStickerType, col: 4},
        {name: 'status', title: 'status.title', options: this.listStickerStatus, default: '', type: 'status', col: 4},
        {name: 'posted_date', title: 'sticker.stick_date', default: '', type: 'date', col: 5},
        {name: 'cancelled_date', title: 'sticker.cancel_date', default: '', type: 'date', col: 5},
        {name: 'deleted', label: 'deleted', default: '', type: 'checkbox', col: 2},
      ];
      this.sharedService.showLoading(false);
      this.getData();
    });
  }

  getData(event?: any) {
    this.sharedService.showLoading(true);
    if (event) {
      Object.keys(event).forEach((key: any) => {
        if (key === 'page') {
          this.filter[key] = event[key] + 1;
        } else {
          this.filter[key] = event[key];
        }
      })
    }
    this.service.searchWithMeta('sticker_tran', {
      fields: ['*.*'],
      "limit": this.filter.limit,
      "page": this.filter.page,
      'sort': [this.filter['sort']],
      filter: formatFilter(this.filter, this.filterConfig)
    }).then((res: any) => {
      this.source = res.data;
      this.totalRows = res.total;
      this.sharedService.showLoading(false);
    });
  }

  onChangePage(event: any) {
    this.filter.page = event;
    this.getData();
  }

  onChangeSize(event: any) {
    this.filter.limit = event;
    this.getData();
  }

  showModal(mode: string) {
    const modalRef = this.modalService.create({
      nzContent: ModalImportComponent,
      nzWidth: '500px',
      nzClassName: 'modal-import-import',
      nzData: {
        mode: mode,
        listStickerType: this.listStickerType
      },
    });
    modalRef.afterClose.subscribe(result => {
      if (result) {
        this.getData();
      }
    });
  }

  export() {
    this.sharedService.showLoading(true);
    this.service.search('sticker_tran', {
      fields: ['*'],
      "limit": this.totalRows,
      "page": 0,
      'sort': [this.filter['sort']],
      filter: formatFilter(this.filter, this.filterConfig)
    }).then((dataResult: any) => {
      let configColumn = this.tableConfig.map((item: any) => {
        return {
          headerText: item.title,
          field: item.name
        }
      })
      let listExport: any[] = [];
      if (dataResult?.length > 0) {
        dataResult.forEach((data: any) => {
          let item: any = {};
          configColumn.forEach(e => {
            item[this.translate.instant(e.headerText)] = typeof data[e.field] === "number" ? data[e.field].toString() : (data[e.field] || '');
            if (e.field.includes('date') && data[e.field]) {
              item[this.translate.instant(e.headerText)] = moment(data[e.field]).format('DD/MM/YYYY');
            }
            if (e.field === 'type' && data[e.field]) {
              item[this.translate.instant(e.headerText)] = this.listStickerType.find((r: any) => r.value === data[e.field])?.text || '';
            }
            if (e.field === 'status' && data[e.field]) {
              item[this.translate.instant(e.headerText)] = this.translate.instant(this.listStickerStatus.find((r: any) => r.value === data[e.field])?.text || '');
            }
          })
          listExport.push(item);
        })
      } else {
        let item: any = {};
        configColumn.forEach(e => {
          item[this.translate.instant(e.headerText)] = '';
          listExport.push(item);
        })
      }
      exportAsExcelFile(listExport, this.translate.instant('sticker.title') + '_' + this.datePipe.transform(new Date(), 'yyMMdd'), this.noti, this.translate);
      this.sharedService.showLoading(false);
    }, (error: any) => {
      this.service.handleError(error)
    }).catch((error: any) => {
      if (error?.errors && error?.errors.length) {
        this.service.handleError(error)
      } else {
        // this.noti.error()
      }
    });
  }

  onSort(event: any) {
    this.tableConfig.forEach((col) => {
      if (col['name'] === event) {
        this.filter['sort'] = col['sortBy'] === 'ASC' ? event : '-' + event;
        col['sortBy'] = col['sortBy'] === 'ASC' ? 'DESC' : 'ASC';
      } else {
        col['sortBy'] = 'ASC'
      }
    });
    this.getData();
  }

  view(event: any) {
    const modalRef = this.modalService.create({
      nzContent: ModalViewComponent,
      nzWidth: '50vw',
      nzClassName: 'modal-view',
      nzData: {
        data: event,
        listStickerType: this.listStickerType,
        listStickerStatus: this.listStickerStatus
      },
    });
    modalRef.afterClose.subscribe(result => {
      if (result) {
        this.getData();
      }
    });
  }

  deleted(event: any) {
    this.service.delete('sticker_tran', event.id).then(res => {
      this.noti.create('success', '', this.translate.instant('sticker.deleteSuccess'));
      this.getData();
    }).catch((error: any) => {
      this.service.handleError(error)
    });
  }
}
